/**
 * Veeso LLM API definitions
 */

import { defHTTP } from '../../api-builder';
import type { LLMGenerateRequest, LLMGenerateResponse } from './types';

/**
 * LLM API definitions for use with apiBuilder
 */
export const llmAPIDefinitions = {
  /**
   * Create LLM generation task
   */
  createLLMTask: defHTTP<LLMGenerateRequest, LLMGenerateResponse>('POST', '/v1/gen'),
};
